import Vue from 'vue';
import assignDeep from 'assign-deep';

export default {

	SAVE_APPLICATION_OPTIONS: (state, payload) => {

		Vue.set(state, 'options', payload);

	},

	SAVE_ASSET_TYPES: (state, payload) => {

		Vue.set(state, 'assetTypes', payload);

	},

	SAVE_VALIDATE_ALL: (state, payload) => {

		Vue.set(state, 'validateAll', payload);

	},

	SAVE_APPLICATION_INFO: (state, payload) => {

		if (payload === false) {

			Vue.set(state, 'info', {
				data: {},
				errors: {}
			});

			return;

		}

		// Avoid storing the same object reference as UploadFiles (or other screens) uses for
		// `uploadTypes`; otherwise in-place edits (e.g. documents.splice) trigger strict-mode
		// "mutate vuex state outside mutation" errors.
		let payloadToMerge = payload;
		if (payload && payload.data && payload.data.uploadTypes && typeof payload.data.uploadTypes === 'object') {
			try {
				payloadToMerge = {
					...payload,
					data: {
						...payload.data,
						uploadTypes: JSON.parse(JSON.stringify(payload.data.uploadTypes))
					}
				};
			} catch {
				payloadToMerge = payload;
			}
		}

		Vue.set(state, 'info', assignDeep(state.info, payloadToMerge));

	},

	SAVE_APPLICATION_SECTIONS: (state, payload) => {

		if (payload === false) {

			Vue.set(state, 'sections', {
				curAddressLess: false
			});

			return;

		}

		Vue.set(state, 'sections', assignDeep(state.sections, payload));

	},

	SAVE_CO_BORROWER: (state, payload) => {

		if (payload === false) {

			Vue.set(state, 'coBorrower', {
				data: {},
				errors: {}
			});

			return;

		}

		Vue.set(state, 'coBorrower', assignDeep(state.coBorrower, payload));

	},

	SAVE_APPLICATION_LIST_ITEM: (state, payload) => {

		if (!payload.key) {

			return false;

		}

		Vue.set(state.applicationLists, payload.key, payload);

		return true;

	}

};
